export const SET_PANEL = 'SET_PANEL';
export const SET_MODULE = 'SET_MODULE';
export const SET_LOADING_MAP = 'SET_LOADING_MAP';
export const SET_ACTION_MAP = 'SET_ACTION_MAP';
export const SET_CONFIG_MAP = 'SET_CONFIG_MAP';
export const SET_FILTERS_MAP = 'SET_FILTERS_MAP';
export const UPDATE_FILTER_ITEM_MAP = 'UPDATE_FILTER_ITEM_MAP';
export const SET_USER_FEATURE_MAP = 'SET_USER_FEATURE_MAP';
export const LOAD_STATE = 'LOAD_STATE';
